import VueGtag from 'vue-gtag';

export const initializeAnalytics = (Vue, router) => {
    console.log('Initializing Google Analytics...');

    if (!process.env.VUE_APP_GA_TRACKING_ID) {
        console.warn('Google Analytics tracking ID is not set. Skipping analytics initialization.');
        return;
    }

    if (!process.env.VUE_ADM_PAGE) { 
        console.warn('VUE_ADM_PAGE environment variable is not set. Skipping analytics initialization.');
        return;
    }

    if (!process.env.VUE_ADM_PAGE.includes('adm.voompcreators.com.br')) {
        console.warn('The current page is not adm.voompcreators.com.br. Skipping analytics initialization.');
        return;
    }

    Vue.use(VueGtag, { 
        config: { id: process.env.VUE_APP_GA_TRACKING_ID }
    }, router);

    console.log('Google Analytics initialized successfully.');
};